import "core-js/modules/es6.regexp.to-string";
import _objectSpread from "@babel/runtime-corejs2/helpers/esm/objectSpread";
import _typeof from "@babel/runtime-corejs2/helpers/esm/typeof";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
var defaultLogLevel = 'none';
var levelOrder = ['none', 'fail', 'error', 'warn', 'info', 'debug', 'trace'];
export var Logger =
/*#__PURE__*/
function () {
  function Logger(defaultLogLevel) {
    _classCallCheck(this, Logger);

    _defineProperty(this, "logLevel", void 0);

    this.logLevel = defaultLogLevel;
  }

  _createClass(Logger, [{
    key: "fail",
    value: function fail(message, data) {
      this.log('fail', message, data);
    }
  }, {
    key: "error",
    value: function error(message, data) {
      this.log('error', message, data);
    }
  }, {
    key: "warn",
    value: function warn(message, data) {
      this.log('warn', message, data);
    }
  }, {
    key: "info",
    value: function info(message, data) {
      this.log('info', message, data);
    }
  }, {
    key: "debug",
    value: function debug(message, data) {
      this.log('debug', message, data);
    }
  }, {
    key: "trace",
    value: function trace(message, data) {
      this.log('trace', message, data);
    }
  }, {
    key: "checkLogLevel",
    value: function checkLogLevel(level, minLevel) {
      return levelOrder.indexOf(level) <= levelOrder.indexOf(minLevel);
    }
  }, {
    key: "log",
    value: function log(level, message, data) {
      if (level === 'none') return;
      var obj = _typeof(data) === 'object' ? _objectSpread({}, data) : undefined;

      if (obj && obj.error instanceof Error) {
        // pulls out error
        obj.stack = obj.error.stack.toString();
        obj.stackMessage = obj.error.message.toString();
        obj.error = undefined; // dont want to log error
      }

      if (typeof console === 'undefined') return; // console logging

      if (this.checkLogLevel(level, this.logLevel)) {
        var consoleFn = console.log;

        if (this.checkLogLevel(level, 'error')) {
          consoleFn = console.error;
        } else if (this.checkLogLevel(level, 'warn')) {
          consoleFn = console.warn;
        }

        var msg = "[".concat(level, "] ").concat(message);

        if (data) {
          consoleFn(msg, data);

          if (data.error) {
            console.error(data.error);
          }
        } else {
          consoleFn(msg);
        }
      }
    }
  }]);

  return Logger;
}();
export var logger = new Logger(defaultLogLevel);